<template>
  <li>
    <router-link :to="{ name: 'graduates', query: { program_id: placement.program_id, placement_id: placement.id } }">
      <div class="row">
        <div class="col-12 col-md-6 col-lg-8 d-flex align-items-center">
          <p class="text-truncate strong">{{ placement.number }} - {{ placement.program.name }}</p>
        </div>
        <div class="col-6 col-md-3 col-lg-2 d-flex align-items-center">
          <p>
            <span class="data-label mt-0">Graduates</span>
            {{ placement.placements_count }}
          </p>
        </div>
        <div class="col-6 col-md-3 col-lg-2 d-flex align-items-center">
          <p>
            <span class="data-label mt-0">Completion</span>
            {{ completionPercentage }}%
          </p>
        </div>
      </div><!-- /.row -->
    </router-link>
  </li>
</template>

<script>
import { round } from 'lodash'
export default {
  props: {
    placement: {
      required: true,
      type: Object
    }
  },

  computed: {
    completionPercentage () {
      if (this.placement.placements_count <= 0) {
        return 0
      }

      return round((this.placement.finalised_placements_count / this.placement.placements_count) * 100)
    }
  }
}
</script>
